export enum NotificationType {
  PayRollBatch = 'pay_role_batch',
  UserBatch = 'user_batch',
  VehicleBatch = 'vehicle_batch',
 }
 